import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Collapse } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Button,
} from '@cordata/buffet';
import classnames from 'classnames';

const SimpleCollapse = ({ title, body, className }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () =>
    setIsOpen(!isOpen);

  return (
    <div className={classnames(className)}>
      <Button onClick={toggle} color="none" className="text-left p-0">
        <FontAwesomeIcon
          icon={isOpen ? 'chevron-down' : 'chevron-right'}
          className="mr-2 text-primary"
          fixedWidth
          size="sm"
        />
        {title}
      </Button>

      {isOpen
        ? (
          <Collapse isOpen className="ml-4">
            {body}
          </Collapse>
        ) : null}
    </div>
  );
};

SimpleCollapse.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
  ]).isRequired,
  body: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
  ]).isRequired,
  className: PropTypes.string,
};

SimpleCollapse.defaultProps = {
  className: undefined,
};

export default SimpleCollapse;
